import { render, staticRenderFns } from "./FavouritesTable.vue?vue&type=template&id=751c784b"
import script from "./FavouritesTable.vue?vue&type=script&lang=js"
export * from "./FavouritesTable.vue?vue&type=script&lang=js"
import style0 from "./FavouritesTable.vue?vue&type=style&index=0&id=751c784b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports